import React from 'react';

interface FeaturedProviderCardSkeletonProps {
  count?: number;
}

const FeaturedProviderCardSkeleton: React.FC<FeaturedProviderCardSkeletonProps> = ({ count = 3 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="bg-white rounded-xl sm:rounded-2xl shadow-lg overflow-hidden border-2 border-accent-200 animate-pulse relative"
        >
          {/* Featured Badge placeholder */}
          <div className="absolute top-3 left-3 z-10">
            <div className="h-6 w-20 bg-accent-200 rounded-full" />
          </div>

          {/* Image placeholder */}
          <div className="h-36 sm:h-48 bg-gray-200" />

          {/* Content */}
          <div className="p-4 sm:p-5 space-y-3">
            {/* Name */}
            <div className="h-5 sm:h-6 bg-gray-200 rounded w-3/4" />

            {/* Category badge */}
            <div className="h-5 bg-accent-100 rounded-full w-24" />

            {/* Location */}
            <div className="flex items-center gap-1">
              <div className="h-4 w-4 bg-gray-200 rounded" />
              <div className="h-4 bg-gray-200 rounded w-1/3" />
            </div>

            {/* Bio */}
            <div className="space-y-1.5">
              <div className="h-3 bg-gray-200 rounded w-full" />
              <div className="h-3 bg-gray-200 rounded w-2/3" />
            </div>

            {/* Book Now button */}
            <div className="h-10 bg-accent-200 rounded-lg w-full" />
          </div>
        </div>
      ))}
    </>
  );
};

export default FeaturedProviderCardSkeleton;
